import { render, staticRenderFns } from "./notification.nav-item.vue?vue&type=template&id=14962d66&"
import script from "./notification.nav-item.vue?vue&type=script&lang=js&"
export * from "./notification.nav-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports